import usePost from "@/hooks/usePost";
import { useLoggedIn } from "@/store/useAuthStore";
import { useRouter } from "next/navigation";
import { MouseEventHandler } from "react";
import CustomNavLink from "../CustomLink/CustomNavLink";
import Image from "next/image";
import { useDictionary } from "../DictProvider/DictProvider";
import { useWishListStore } from "@/store/useWishList";
import { useCartStore } from "@/store/useCartStore";
import toast from "react-hot-toast";
import LangSwitch from "../TopBar/component/LangSwitch";
import { useNotifyStore } from "@/store/useNotify";
import useCart from "@/hooks/useCart";
import useImageUrlModifier from "@/lib/useImageUrlModifier";

interface Menuprops {
  closepopup?: MouseEventHandler;
}
const MenuItem: React.FC<Menuprops> = ({ closepopup }) => {
  const dictionary = useDictionary();
  const modifyImageUrl = useImageUrlModifier();

  const { logout, profile } = useLoggedIn();
  const router = useRouter();
  const { PostMethod } = usePost();
  const { clearWishList } = useWishListStore();
  const { clearCart } = useCartStore();
  const { getCartList } = useCart();
  const { clearNotify } = useNotifyStore();

  const userLogout = (e: any) => {
    const tID = toast.loading("Loading...");
    PostMethod({
      url: "user/logout",
      method: "get",
    }).then((res) => {
      if (res.success === true) {
        toast.dismiss(tID);
        toast.success(res?.message || "Logout Successfully");
        if (closepopup) {
          closepopup(e);
        }
        logout(false);
        clearWishList();
        clearCart();
        clearNotify();
        getCartList();

        router.push("/");
        return;
      }
      toast.dismiss(tID);
      toast.success("Something Went Wrong");
    });
  };

  return (
    <div className="grid grid-cols-1 divide-y">
      <CustomNavLink prefetch={false} href="profile">
        <div onClick={closepopup} className="flex items-center cursor-pointer">
          <div className="p-4">
            <div className="w-10 h-10 relative ">
              <Image
                className=" object-cover rounded-full"
                src={
                  profile?.userImage
                    ? modifyImageUrl(profile.userImage, 100, 100) ||
                      "/images/menuBlankIcon.svg"
                    : "/images/menuBlankIcon.svg"
                }
                fill
                alt="profile"
                quality={80}
                priority={true}
              />
            </div>
          </div>
          <div>
            <p className="text-primary">
              Hi,{" "}
              {profile?.firstName?.charAt(0)?.toUpperCase() +
                profile?.firstName?.slice(1)}
            </p>
          </div>
        </div>
      </CustomNavLink>

      <div className="flex items-center">
        <div className="px-4 py-3">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.5666 2.64796C14.6572 2.824 14.6801 3.05004 14.7249 3.50212C14.8103 4.35629 14.853 4.78337 15.0322 5.01879C15.1438 5.16496 15.2922 5.27897 15.4621 5.34922C15.6321 5.41948 15.8177 5.44348 15.9999 5.41879C16.2916 5.38025 16.6249 5.10837 17.2895 4.56462C17.6405 4.27608 17.8166 4.13233 18.0051 4.07192C18.2453 3.99518 18.5051 4.00814 18.7364 4.10837C18.9187 4.18754 19.0801 4.34796 19.3999 4.66879L20.3312 5.60004C20.652 5.92087 20.8124 6.08129 20.8916 6.26358C20.9918 6.49489 21.0048 6.7547 20.928 6.99483C20.8676 7.18337 20.7239 7.35942 20.4364 7.71046C19.8916 8.37608 19.6197 8.70837 19.5801 9.00108C19.5557 9.18327 19.58 9.36866 19.6504 9.53844C19.7209 9.70821 19.835 9.85633 19.9812 9.96775C20.2155 10.1469 20.6437 10.1896 21.4989 10.275C21.9499 10.3198 22.176 10.3427 22.353 10.4334C22.5764 10.5492 22.7503 10.742 22.8426 10.9761C22.9166 11.1605 22.9166 11.3875 22.9166 11.8417V13.1584C22.9166 13.6125 22.9166 13.8396 22.8437 14.023C22.7511 14.2578 22.5764 14.451 22.352 14.5667C22.176 14.6573 21.9499 14.6802 21.4978 14.725C20.6437 14.8105 20.2166 14.8532 19.9812 15.0323C19.835 15.144 19.721 15.2923 19.6507 15.4623C19.5805 15.6322 19.5565 15.8178 19.5812 16C19.6208 16.2917 19.8926 16.625 20.4364 17.2896C20.7239 17.6407 20.8676 17.8157 20.928 18.0052C21.0048 18.2454 20.9918 18.5052 20.8916 18.7365C20.8124 18.9188 20.652 19.0792 20.3312 19.4L19.3999 20.3302C19.0791 20.6521 18.9187 20.8125 18.7364 20.8907C18.5051 20.9909 18.2453 21.0039 18.0051 20.9271C17.8166 20.8667 17.6405 20.723 17.2895 20.4355C16.6239 19.8917 16.2916 19.6198 15.9999 19.5813C15.8177 19.5566 15.6321 19.5806 15.4621 19.6509C15.2922 19.7211 15.1438 19.8351 15.0322 19.9813C14.853 20.2157 14.8103 20.6427 14.7249 21.498C14.6801 21.95 14.6572 22.1761 14.5666 22.3521C14.4512 22.5763 14.2583 22.751 14.0239 22.8438C13.8395 22.9167 13.6124 22.9167 13.1583 22.9167H11.8416C11.3874 22.9167 11.1603 22.9167 10.977 22.8438C10.7422 22.7512 10.5489 22.5765 10.4333 22.3521C10.3426 22.1761 10.3197 21.95 10.2749 21.498C10.1895 20.6438 10.1468 20.2167 9.96763 19.9813C9.85609 19.8353 9.70792 19.7214 9.53815 19.6511C9.36838 19.5809 9.18305 19.5568 9.00096 19.5813C8.70825 19.6198 8.37596 19.8917 7.71034 20.4355C7.35929 20.724 7.18325 20.8677 6.99471 20.9282C6.75458 21.0049 6.49477 20.9919 6.26346 20.8917C6.08117 20.8125 5.91971 20.6521 5.59992 20.3313L4.66867 19.4C4.34784 19.0792 4.18742 18.9188 4.10825 18.7365C4.00801 18.5052 3.99506 18.2454 4.07179 18.0052C4.13221 17.8167 4.27596 17.6407 4.56346 17.2896C5.10825 16.624 5.38013 16.2917 5.41867 15.999C5.44317 15.8169 5.41907 15.6316 5.34882 15.4618C5.27857 15.292 5.16467 15.1439 5.01867 15.0323C4.78429 14.8532 4.35617 14.8105 3.50096 14.725C3.04992 14.6802 2.82388 14.6573 2.64679 14.5667C2.42341 14.4509 2.2495 14.2581 2.15721 14.024C2.08325 13.8396 2.08325 13.6125 2.08325 13.1584V11.8417C2.08325 11.3875 2.08325 11.1605 2.15617 10.9771C2.24876 10.7423 2.42348 10.5491 2.64784 10.4334C2.82388 10.3427 3.04992 10.3198 3.502 10.275C4.35617 10.1896 4.78429 10.1469 5.01867 9.96775C5.16486 9.85633 5.27896 9.70821 5.3494 9.53844C5.41984 9.36866 5.44409 9.18327 5.41971 9.00108C5.38013 8.70837 5.10721 8.37608 4.56346 7.70942C4.27596 7.35837 4.13221 7.18337 4.07179 6.99379C3.99506 6.75366 4.00801 6.49385 4.10825 6.26254C4.18742 6.08129 4.34784 5.91983 4.66867 5.599L5.59992 4.66879C5.92075 4.34796 6.08117 4.1865 6.26346 4.10837C6.49477 4.00814 6.75458 3.99518 6.99471 4.07192C7.18325 4.13233 7.35929 4.27608 7.71034 4.56358C8.37596 5.10733 8.70825 5.37921 8.99992 5.41879C9.18243 5.44356 9.36825 5.41949 9.53843 5.34904C9.70861 5.27859 9.85707 5.16427 9.96867 5.01775C10.1458 4.78337 10.1895 4.35629 10.2749 3.50108C10.3197 3.05004 10.3426 2.824 10.4333 2.64692C10.5489 2.42314 10.7417 2.24884 10.976 2.15629C11.1603 2.08337 11.3874 2.08337 11.8416 2.08337H13.1583C13.6124 2.08337 13.8395 2.08337 14.0228 2.15629C14.2577 2.24888 14.4509 2.4236 14.5666 2.64796ZM12.4999 16.6667C13.605 16.6667 14.6648 16.2277 15.4462 15.4463C16.2276 14.6649 16.6666 13.6051 16.6666 12.5C16.6666 11.395 16.2276 10.3352 15.4462 9.55376C14.6648 8.77236 13.605 8.33337 12.4999 8.33337C11.3948 8.33337 10.335 8.77236 9.55364 9.55376C8.77224 10.3352 8.33325 11.395 8.33325 12.5C8.33325 13.6051 8.77224 14.6649 9.55364 15.4463C10.335 16.2277 11.3948 16.6667 12.4999 16.6667Z"
              fill="#AC7529"
              fillOpacity="0.8"
            />
          </svg>
        </div>
        <div>
          <CustomNavLink
            href="user"
            className="hover:font-bold"
            prefetch={false}
          >
            <p className="text-primary" onClick={closepopup}>
              {dictionary?.registerPage?.yourAccount}
            </p>
          </CustomNavLink>
        </div>
      </div>

      <div className="flex items-center">
        <div className="px-4 py-3">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.7087 18.75C16.5524 18.75 15.6253 19.6771 15.6253 20.8334C15.6253 21.3859 15.8448 21.9158 16.2355 22.3065C16.6262 22.6972 17.1561 22.9167 17.7087 22.9167C18.2612 22.9167 18.7911 22.6972 19.1818 22.3065C19.5725 21.9158 19.792 21.3859 19.792 20.8334C19.792 20.2808 19.5725 19.7509 19.1818 19.3602C18.7911 18.9695 18.2612 18.75 17.7087 18.75ZM1.04199 2.08337V4.16671H3.12533L6.87533 12.073L5.45866 14.625C5.30241 14.9167 5.20866 15.2605 5.20866 15.625C5.20866 16.1776 5.42815 16.7075 5.81885 17.0982C6.20955 17.4889 6.73946 17.7084 7.29199 17.7084H19.792V15.625H7.72949C7.66043 15.625 7.59419 15.5976 7.54535 15.5488C7.49651 15.4999 7.46908 15.4337 7.46908 15.3646C7.46908 15.3125 7.47949 15.2709 7.50033 15.2396L8.43783 13.5417H16.1982C16.9795 13.5417 17.667 13.1042 18.0212 12.4688L21.7503 5.72921C21.8232 5.56254 21.8753 5.38546 21.8753 5.20837C21.8753 4.93211 21.7656 4.66716 21.5702 4.4718C21.3749 4.27645 21.1099 4.16671 20.8337 4.16671H5.42741L4.44824 2.08337M7.29199 18.75C6.13574 18.75 5.20866 19.6771 5.20866 20.8334C5.20866 21.3859 5.42815 21.9158 5.81885 22.3065C6.20955 22.6972 6.73946 22.9167 7.29199 22.9167C7.84453 22.9167 8.37443 22.6972 8.76513 22.3065C9.15583 21.9158 9.37533 21.3859 9.37533 20.8334C9.37533 20.2808 9.15583 19.7509 8.76513 19.3602C8.37443 18.9695 7.84453 18.75 7.29199 18.75Z"
              fill="#AC7529"
              fillOpacity="0.8"
            />
          </svg>
        </div>
        <div>
          <CustomNavLink
            href={`orders`}
            className=" hover:font-bold"
            prefetch={false}
          >
            <p className="text-primary" onClick={closepopup}>
              {dictionary?.registerPage?.yourOrders}
            </p>
          </CustomNavLink>
        </div>
      </div>

      <div className="flex items-center">
        <div className="px-4 py-3">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.4375 9.17969C23.4375 16.0156 13.3018 21.5488 12.8701 21.7773C12.7563 21.8385 12.6292 21.8706 12.5 21.8706C12.3708 21.8706 12.2436 21.8385 12.1299 21.7773C11.6982 21.5488 1.5625 16.0156 1.5625 9.17969C1.56431 7.57444 2.20279 6.03546 3.33788 4.90038C4.47296 3.76529 6.01194 3.12681 7.61719 3.125C9.63379 3.125 11.3994 3.99219 12.5 5.45801C13.6006 3.99219 15.3662 3.125 17.3828 3.125C18.9881 3.12681 20.527 3.76529 21.6621 4.90038C22.7972 6.03546 23.4357 7.57444 23.4375 9.17969Z"
              fill="#AC7529"
              fillOpacity="0.8"
            />
          </svg>
        </div>
        <div>
          <CustomNavLink
            href={`wishlist`}
            className=" hover:font-bold"
            prefetch={false}
          >
            <p className="text-primary" onClick={closepopup}>
              {dictionary?.registerPage?.yourWishlist}
            </p>
          </CustomNavLink>
        </div>
      </div>
      
      <div className="flex items-center">
        <div className="px-4 py-3">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.4999 11.9792C11.8093 11.9792 11.1469 11.7048 10.6585 11.2165C10.1701 10.7281 9.89575 10.0657 9.89575 9.37504C9.89575 8.68437 10.1701 8.02199 10.6585 7.53362C11.1469 7.04524 11.8093 6.77087 12.4999 6.77087C13.1906 6.77087 13.853 7.04524 14.3413 7.53362C14.8297 8.02199 15.1041 8.68437 15.1041 9.37504C15.1041 9.71702 15.0367 10.0557 14.9059 10.3716C14.775 10.6876 14.5832 10.9746 14.3413 11.2165C14.0995 11.4583 13.8124 11.6501 13.4965 11.781C13.1805 11.9118 12.8419 11.9792 12.4999 11.9792ZM12.4999 2.08337C10.566 2.08337 8.71138 2.8516 7.34393 4.21905C5.97648 5.58651 5.20825 7.44117 5.20825 9.37504C5.20825 14.8438 12.4999 22.9167 12.4999 22.9167C12.4999 22.9167 19.7916 14.8438 19.7916 9.37504C19.7916 7.44117 19.0234 5.58651 17.6559 4.21905C16.2885 2.8516 14.4338 2.08337 12.4999 2.08337Z"
              fill="#AC7529"
              fillOpacity="0.8"
            />
          </svg>
        </div>
        <div>
          <CustomNavLink
            href="address"
            className=" hover:font-bold"
            prefetch={false}
          >
            <p className="text-primary" onClick={closepopup}>
              {dictionary?.registerPage?.saveAddress}
            </p>
          </CustomNavLink>
        </div>
      </div>

      <div className="flex items-center">
        <div className="px-4 py-3">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_1717_26744)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.4768 2.67952C11.7303 2.66604 10.9885 2.7999 10.2938 3.07344C9.59908 3.34698 8.96514 3.75483 8.42824 4.27365C7.89134 4.79246 7.46203 5.41207 7.16486 6.09699C6.8677 6.78192 6.70852 7.51872 6.69643 8.26523V16.0724C6.69643 16.546 6.50829 17.0002 6.1734 17.3351C5.83852 17.67 5.38432 17.8581 4.91071 17.8581H2.67857C1.96817 17.8581 1.28686 17.5759 0.784535 17.0736C0.282206 16.5712 0 15.8899 0 15.1795L0 11.6081C0 10.8977 0.282206 10.2164 0.784535 9.71405C1.28686 9.21173 1.96817 8.92952 2.67857 8.92952H4.01786V8.23309C4.03415 7.13558 4.26649 6.05203 4.70159 5.04432C5.1367 4.03661 5.76606 3.12448 6.55373 2.36003C7.34139 1.59558 8.27193 0.993786 9.2922 0.589011C10.3125 0.184235 11.4025 -0.0155897 12.5 0.000948775C13.5975 -0.0155897 14.6875 0.184235 15.7078 0.589011C16.7281 0.993786 17.6586 1.59558 18.4463 2.36003C19.2339 3.12448 19.8633 4.03661 20.2984 5.04432C20.7335 6.05203 20.9658 7.13558 20.9821 8.23309V8.92952H22.3214C23.0318 8.92952 23.7131 9.21173 24.2155 9.71405C24.7178 10.2164 25 10.8977 25 11.6081V15.1795C25 15.8899 24.7178 16.5712 24.2155 17.0736C23.7131 17.5759 23.0318 17.8581 22.3214 17.8581H20.9821V18.7509C20.9824 19.9577 20.5383 21.1222 19.7346 22.0224C18.931 22.9225 17.824 23.4953 16.625 23.6313C16.3921 24.047 16.0526 24.3931 15.6414 24.6339C15.2302 24.8747 14.7622 25.0014 14.2857 25.0009H11.6071C10.8967 25.0009 10.2154 24.7187 9.71311 24.2164C9.21078 23.7141 8.92857 23.0328 8.92857 22.3224C8.92857 21.612 9.21078 20.9307 9.71311 20.4283C10.2154 19.926 10.8967 19.6438 11.6071 19.6438H14.2857C15.2536 19.6438 16.1018 20.1563 16.5714 20.9259C17.0636 20.8128 17.5029 20.5361 17.8175 20.1411C18.1321 19.746 18.3035 19.256 18.3036 18.7509V8.26345C18.2913 7.51309 18.1305 6.7726 17.8303 6.08479C17.5301 5.39698 17.0966 4.77549 16.5548 4.25625C16.0129 3.73701 15.3736 3.33031 14.6736 3.05968C13.9736 2.78904 13.227 2.65983 12.4768 2.67952Z"
                fill="#AC7529"
              />
            </g>
            <defs>
              <clipPath id="clip0_1717_26744">
                <rect width="25" height="25" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div>
          {" "}
          <CustomNavLink
            href="contact-us"
            className=" hover:font-bold"
            prefetch={false}
          >
            <p className="text-primary" onClick={closepopup}>
              {dictionary?.registerPage?.contactus}
            </p>
          </CustomNavLink>
        </div>
      </div>

      <div className="flex items-center">
        <div className="px-4 py-3">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.125 21.875V3.125H12.5V5.20833H5.20833V19.7917H12.5V21.875H3.125ZM16.6667 17.7083L15.2344 16.1979L17.8906 13.5417H9.375V11.4583H17.8906L15.2344 8.80208L16.6667 7.29167L21.875 12.5L16.6667 17.7083Z"
              fill="#AC7529"
              fillOpacity="0.8"
            />
          </svg>
        </div>
        <div
          className="text-primary cursor-pointer hover:font-bold"
          onClick={userLogout}
        >
          <p>{dictionary?.registerPage?.logout}</p>
        </div>
      </div>

      <div className="flex items-center lg:hidden px-5">
        <LangSwitch />
      </div>
    </div>
  );
};

export default MenuItem;
